import React from 'react';
import { Text } from 'react-native';
import { toRevealTokens, tokenValue } from '../richText/revealTokens';

// const delayShape = PropTypes.shape({
//   at: PropTypes.oneOfType([
//     PropTypes.string,
//     PropTypes.number,
//     PropTypes.instanceOf(RegExp),
//   ]),
//   delay: PropTypes.number,
// });
//
// const propTypes = {
//   fixed: PropTypes.bool,
//   delayMap: PropTypes.arrayOf(PropTypes.shape(delayShape)),
//   typing: PropTypes.number,
//   maxDelay: PropTypes.number,
//   minDelay: PropTypes.number,
//   onTypingEnd: PropTypes.func,
//   onTyped: PropTypes.func,
//   text: PropTypes.string,
//   typeWriterStyle: Text.propTypes.style,
// };

const defaultProps = {
  typing: 0,
  maxDelay: 100,
  minDelay: 20,
};

class TypeWriter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleChars: 0,
    };

    // Unités de dévoilement, et non caractères bruts : la prose se dévoile
    // lettre à lettre, une formule d'un seul bloc — dévoiler `\frac{3}{4}`
    // caractère par caractère afficherait de la syntaxe cassée avant de sauter.
    // Sans formule dans le texte, un jeton vaut exactement un caractère : le
    // comportement de ce composant, partagé par tous les champions, est alors
    // inchangé (cf. `toRevealTokens`).
    this._tokens = toRevealTokens(props.text);

    this._handleTimeout = this._handleTimeout.bind(this);
  }

  componentDidMount() {
    this._timeoutId = setTimeout(this._handleTimeout, this.props.minDelay);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const next = nextProps.typing;
    const active = this.props.typing;

    if (this.props.text !== nextProps.text) {
      this._tokens = toRevealTokens(nextProps.text);
      this.setState({
        visibleChars: 0,
      });
    } else {
      if (active > 0 && next < 0) {
        this.setState({
          visibleChars: this.state.visibleChars - 1,
        });
      } else if (active <= 0 && next > 0) {
        this.setState({
          visibleChars: this.state.visibleChars + 1,
        });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.visibleChars !== nextState.visibleChars ||
      this.props.text !== nextProps.text
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      maxDelay,
      minDelay,
      delayMap,
      onTyped,
      onTypingEnd,
    } = this.props;
    const { visibleChars } = prevState;
    const token = tokenValue(this._tokens[visibleChars]);
    const nextToken = tokenValue(this._tokens[this.state.visibleChars]);

    if (token && onTyped) {
      onTyped(token, visibleChars);
    }

    if (nextToken) {
      let timeout = ~~(Math.random() * (maxDelay - minDelay) + minDelay);

      if (delayMap) {
        delayMap.forEach(({ at, delay }) => {
          if (at === visibleChars || (token && token.match(at))) {
            timeout += delay;
          }
        });
      }

      this._timeoutId = setTimeout(this._handleTimeout, timeout);
    } else if (onTypingEnd) {
      onTypingEnd();
    }
  }

  componentWillUnmount() {
    clearInterval(this._timeoutId);
  }

  _handleTimeout() {
    const { typing } = this.props;
    const { visibleChars } = this.state;

    this.setState({
      visibleChars: visibleChars + typing,
    });
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { text, typeWriterStyle, ...props } = this.props;
    const { visibleChars } = this.state;

    // Les jetons portent déjà les formules composées : la concaténation suffit,
    // le rendu reste une simple chaîne dans un seul `<Text>`.
    const revealed = this._tokens
      .slice(0, Math.max(0, visibleChars))
      .map((t) => t.value)
      .join('');

    return <Text style={typeWriterStyle} {...props}>{revealed}</Text>;
  }
}

// TypeWriter.propTypes = propTypes;
TypeWriter.defaultProps = defaultProps;

export default TypeWriter;
